export default __webpack_public_path__ + "media/music/684afa577f153ff2f9911f2258b1b80e.mp3";